module.exports = __webpack_public_path__ + "static/media/zhengshu4.91c97ddf.jpg";